(function($, site) {
  var currentIframe = null;

  $(document).off('elc.iframe.addToBag').on('elc.iframe.addToBag', function(event, $iframe, data) {
    if ('parentIFrame' in window && typeof window.parentIFrame.sendMessage === 'function') {
      handleIFrameAddToBag($iframe, data);
    } else if (site.addToCart) {
      site.addToCart(data);
    } else if (prodcat && prodcat.ui && prodcat.ui.addToCart) {
      prodcat.ui.addToCart(data);
    }
  });

  $(document).off('elc.iframe.overlayOpened').on('elc.iframe.overlayOpened', function(event, data) {

    if (!data || !data.container) {
      return;
    }

    var $container = $(data.container);
    var $iframe = $container.find('iframe');
    var newSku = data.sku;
    var newProductId = data.productId;

    if (!$iframe.length) {
      return;
    }

    currentIframe = $iframe[0];

    var dataSrc = $iframe.attr('data-src');
    if (dataSrc) {
      var newDataSrc = dataSrc;
      if (newProductId) {
        newDataSrc = newDataSrc.replace(/\/product\/[^/?#]+/, '/product/' + newProductId);
      }
      if (newSku) {
        newDataSrc = newDataSrc.replace(/\/sku\/[^/?#]+/, '/sku/' + newSku);
      }
      $iframe.data('src', newDataSrc);
      $iframe.attr('data-src', newDataSrc);
    }

    if ($iframe.data('lockPageScroll')) {
      $('body').addClass('lock-page-scroll');
    }

    // Monkey-patch sendPostMessage once to use fresh overlay iframe
    var behavior = Drupal.behaviors.elcIFrameContentExperienceV1;
    if (behavior && !behavior._originalSendPostMessage) {
      behavior._originalSendPostMessage = behavior.sendPostMessage;
      behavior.sendPostMessage = function($iframeArg, action, data) {
        var iframeEl = $iframeArg.get(0);
        if (currentIframe && currentIframe.contentWindow && (!iframeEl || !iframeEl.contentWindow)) {
          currentIframe.contentWindow.postMessage(
            JSON.stringify({ _elc_action: action, ...data }),
            '*'
          );
          return;
        }
        behavior._originalSendPostMessage($iframeArg, action, data);
      };
    }

    if (behavior) {
      $iframe.removeClass('attached');
      behavior.attach($container[0], Drupal.settings);
    }
  });

  $(document).off('elc.iframe.closeOverlay').on('elc.iframe.closeOverlay', function() {
    $(document).trigger('elc.iframe.overlayClosed');
  });

  $(document).off('elc.iframe.overlayClosed').on('elc.iframe.overlayClosed', function() {
    $('body').removeClass('lock-page-scroll');
    // Don't destroy iFrameResizer - React destroys the DOM on unmount
    currentIframe = null;
    // Restore original sendPostMessage so the patch doesn't linger
    var behavior = Drupal.behaviors.elcIFrameContentExperienceV1;
    if (behavior && behavior._originalSendPostMessage) {
      behavior.sendPostMessage = behavior._originalSendPostMessage;
      delete behavior._originalSendPostMessage;
    }
    document.dispatchEvent(new CustomEvent('elc.overlay.closeRequested'));
  });

  $(document).off('elc.iframe.redirectRequested').on('elc.iframe.redirectRequested', function(event, $iframe, data) {
    if (!data['redirect_url']) {
      return false;
    }
    if (data['new_tab']) {
      window.open(data['redirect_url']);
    } else {
      window.location.href = data['redirect_url'];
    }
  });

  function handleIFrameAddToBag($iframe, data) {
    const parentIframe = window.parentIFrame;
    const args = {
      skuBaseId: data.skuBaseId,
      quantity: data?.QTY || data?.quantity || 1,
      _elc_action: data?.elcModernizedAction || 'addtobag',
      iframeID: parentIFrame?.getId()
    };
    const iframeElement = $iframe?.[0];
    if (iframeElement) {
      args.$addBtn = { data: { ...iframeElement.dataset } };
    }
    parentIframe?.sendMessage(args, '*');
  }
})(jQuery, site || {});
